import type { CreatorEntity as Entity } from "shared/schema";
import { splitEntity } from "shelving";
import { GroupNavigation } from "../group/GroupNavigation.js";
import { ProfileNavigation } from "../profile/ProfileNavigation.js";

export function EntityNavigation({ entity }: { entity: Entity }): React.ReactElement | null {
	const [type, id] = splitEntity(entity);
	if (type === "group") return <GroupNavigation gid={id} />;
	if (type === "profile") return <ProfileNavigation uid={id} />;
	return null;
}
